import Paper from "@mui/material/Paper"
import Grid from "@mui/material/Grid"
import Box from "@mui/material/Box"
import React from "react"
import {AvantColors} from "../../../../styles/AvantColors"
import {BodyText, H1Text, LabelText} from "../../../../styles/AvantTypography"
import {productStore} from "../../../common/products/ProductStore"
import {PLACE_PRODUCT_ID} from "../../../../util/Constants"
import {GroupType} from "../../../common/group/models/GroupMaster"
import LanguageUtils from "../../../../util/LanguageUtils"

export interface GroupData {
    id: number
    type: string
    name: string
}

interface IndividualReportHeaderProps {
    firstName?: string
    lastName?: string
    loginName?: string
    language?: string
    test?: string
    date?: string
    groupData?: GroupData[]
}

export const IndividualReportHeader = (props: IndividualReportHeaderProps) => {
    if (props.groupData === undefined) {
        return <Box/>
    }

    const productId = productStore.loginProduct ? productStore.loginProduct.productId : null
    const {groupData} = props
    const language = LanguageUtils.removeTilde(props.language)

    const districtOrCustomer = groupData.find(group => group.type === GroupType.DISTRICT || group.type === GroupType.CUSTOMER)
    const schoolOrLocation = groupData.find(group => group.type === GroupType.SCHOOL || group.type === GroupType.LOCATION)

    const dateType = productId === PLACE_PRODUCT_ID.value() ? "Finish Date" : "Start Date"

    if (districtOrCustomer === undefined || schoolOrLocation === undefined) {
        return <Box/>
    }

    return (
        <Paper sx={{backgroundColor: AvantColors.REPORT_BACKGROUND_GRAY_DARK, display: "flex", flexDirection: "column", gap: 2, padding: 2}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <H1Text>
            {props.firstName} {props.lastName}
          </H1Text>
        </Grid>
        <Grid item xs={12}>
            {districtOrCustomer.name} | {schoolOrLocation.name}
        </Grid>
        <Grid item xs={12} sm={6} md={3} sx={{display: "flex", gap: 1}}>
            <LabelText>Login Name:</LabelText>
            <BodyText>{props.loginName}</BodyText>
        </Grid>
        <Grid item xs={12} sm={6} md={3} sx={{display: "flex", gap: 1}}>
            <LabelText>Test:</LabelText>
            <BodyText>{props.test}</BodyText>
        </Grid>
        <Grid item xs={12} sm={6} md={3} sx={{display: "flex", gap: 1}}>
            <LabelText>Language:</LabelText>
            <BodyText>{language}</BodyText>
        </Grid>
        <Grid item xs={12} sm={6} md={3} sx={{display: "flex", gap: 1}}>
            <LabelText>{dateType}:</LabelText>
            <BodyText>{props.date}</BodyText>
        </Grid>
      </Grid>
    </Paper>
    )
}

export const LabelAndText = (props: { label: string, text?: string }) => (
    <Box sx={{display: "flex"}}>
        <LabelText>{props.label}:</LabelText>
        <BodyText>{props.text}</BodyText>
    </Box>
)
